import { useAppRouter } from '@/common/route/useAppRouter';
import { validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useAvatarColorAdd() {
    const router = useAppRouter();

    const model = reactive({
        name: '',
        color: ''
    });

    const validations = {
        name: { required },
        color: { required, format: validateFormat(/^[0-9A-Fa-f]{6}$/) }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () => avatarService.color.create(model.name, model.color),
        onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.COLOR.INDEX })
    });

    return { model, v$, create };
}
